const formatters = {
  default: (el) => {
    return {
      value: el.codigo,
      text: el.valor
    }
  },
  selectVal: (el) => {
    return {
      value: el,
      text: el.valor
    }
  },
  selectCity: (el) => {
    return {
      value: el.codigo,
      text: el.nome
    }
  },
  selectState: (el) => {
    return {
      value: el.sigla,
      text: el.nome
    }
  }
};

export default formatters;
